import { useId, useState } from "react";
import { cashbackPercent } from "./cashbackOrdering";

export function estimateCashback(amount, offer) {
  const percent = cashbackPercent(offer);
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(String(amount).trim())) return null;
  const value = Number(String(amount).replace(",", "."));
  if (!Number.isFinite(value) || value <= 0 || value > 1000000 || percent === null || percent <= 0 || percent > 100) return null;
  return Math.round(value * percent) / 100;
}

export default function CashbackEstimate({ offer }) {
  const inputId = useId();
  const [amount, setAmount] = useState("");
  const percent = cashbackPercent(offer);
  if (percent === null || percent <= 0 || percent > 100) return null;
  const value = estimateCashback(amount, offer);
  const maximum = /até/i.test(offer.cashback_text || "");
  return <section aria-label="Simular cashback" className="space-y-2 rounded-xl border border-violet-300/25 bg-violet-300/5 p-4">
    <h3 className="font-bold">Quanto pode voltar para você?</h3>
    <label className="block text-sm" htmlFor={inputId}>Valor dos produtos elegíveis (R$)</label>
    <input id={inputId} inputMode="decimal" value={amount} maxLength={12} placeholder="Ex.: 200,00" onChange={event => setAmount(event.target.value)} className="w-full rounded-lg border border-white/20 bg-zinc-900 p-2 text-white" />
    <p aria-live="polite" className="font-semibold cashback-accent-text">{value !== null ? `${maximum ? "Até " : "Estimativa: "}${value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} de cashback` : amount ? "Informe um valor válido, sem separador de milhar." : "Informe um valor para simular."}</p>
    <p className="text-xs text-zinc-400">Cálculo ilustrativo com {percent.toLocaleString("pt-BR")}% anunciados. Não é saldo nem garantia de recebimento. Categorias, limites, frete, taxas e outras regras podem alterar o valor final. Confira as condições da oferta.</p>
  </section>;
}
